import * as yup from 'yup';

import { requiredField } from '~/ui/constants/errorMessages';

const validationSchema = yup.object().shape({
  teamId: yup.number().required(requiredField),
});

export default validationSchema;
